import React from 'react';

const useTimeout = (callback: Function, delay: number | null) => {
  const timeoutId = React.useRef<number | null>(null);
  const savedCallback = React.useRef(callback);

  React.useEffect(() => {
    savedCallback.current = callback;
  });

  React.useEffect(() => {
    const tick = () => savedCallback.current();

    if (typeof delay === 'number') {
      timeoutId.current = window.setTimeout(tick, delay);

      return () => {
        if (typeof timeoutId.current === 'number') {
          window.clearTimeout(timeoutId.current);
        }
      };
    }
  }, [delay]);

  return timeoutId.current;
};

export default useTimeout;
